import request from '@/utils/request'
import qs from 'qs'

// 获取用户反馈的列表
export const getFeedbackList = (data: any) =>
  request({
    url: '/feedback/list',
    method: 'get',
    params: data
  })

// 导出用户反馈的列表为csv文件
export const exportFeedbackList = (data: any) =>
  request({
    url: '/feedback/export',
    method: 'get',
    params: data
  })

// 回复用户反馈
// 添加VIP
export const replyFeedback = (data: { id: number, content: String }) =>
  request({
    url: '/feedback/reply',
    method: 'post',
    data: qs.stringify(data)
  })
